module.exports = __webpack_public_path__ + "media/warning.783e1f9f.mp3";